module.exports = "//static.hsappstatic.net/connect-dot-com-ui/static-1.384/js/features/users/components/network-introduction.png"